import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

const useAuthStore = create(
  persist(
    (set, get) => ({
      // State
      user: null,
      token: null,
      isAuthenticated: false,
      isLoading: false,

      // Actions
      login: (user, token) => {
        set({
          user,
          token,
          isAuthenticated: true,
          isLoading: false
        })
      },

      logout: () => {
        set({
          user: null,
          token: null,
          isAuthenticated: false,
          isLoading: false
        })
        // Clear localStorage
        localStorage.removeItem('auth-storage')
      },

      updateUser: (userData) => {
        set(state => ({
          user: { ...state.user, ...userData }
        }))
      },

      setLoading: (loading) => {
        set({ isLoading: loading })
      },

      // Getters
      isAdmin: () => {
        const { user } = get()
        return user?.role === 'ADMINISTRADOR'
      },

      canEdit: () => {
        const { user } = get()
        return user?.role === 'ADMINISTRADOR'
      },

      canView: () => {
        const { user } = get()
        return user?.role === 'ADMINISTRADOR' || user?.role === 'CONSULTA'
      }
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        user: state.user,
        token: state.token,
        isAuthenticated: state.isAuthenticated
      })
    }
  )
)

export default useAuthStore
